<div *ngIf="templates$ | async as templates">
    <nova-banner *ngIf="searchResultText" bannerType="search" [bannerMessage]="searchResultText"></nova-banner>
    <mat-radio-group [formControl]="templateSelect">
        <table mat-table [dataSource]="templates" class="nova__table template-list" aria-describedby="template list">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef scope="col"> </th>
                <td mat-cell *matCellDef="let element">
                    <span *ngIf="isTemplateCompatible(element); else incompatible">
                        <mat-radio-button [value]="element"></mat-radio-button>
                    </span>
                    <ng-template #incompatible>
                        <span class="material-icons template-error"
                            matTooltip="The template has multiple documents and is not compatible with Nova integration">error</span>
                    </ng-template>
                </td>
            </ng-container>
            <mat-text-column headerText="Template Title" name="name"></mat-text-column>
            <mat-text-column headerText="Pages" name="pageCount"></mat-text-column>
            <ng-container matColumnDef="preview">
                <th mat-header-cell *matHeaderCellDef scope="col"> Actions </th>
                <td mat-cell *matCellDef="let element">
                    <a class="nova__link" (click)="getTemplateImage(element.id, element.name)">Preview</a>
                </td>
            </ng-container>

            <tr mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                [ngClass]="{'incompatible': !isTemplateCompatible(row)}"></tr>
        </table>
    </mat-radio-group>
</div>